/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/

export default {
  setVinNo(state: { vinNo: string }, payload: string): void {
    state.vinNo = payload;
  },
  setSerialNo(state: { serialNo: string }, payload: string): void {
    state.serialNo = payload;
  },
  setvinNoPattern(state: { vinNoPattern: string }, payload: string): void {
    state.vinNoPattern = payload;
  },
};
